import React from "react";

import { Card, Flex, Image, InputNumber, InputNumberProps, Skeleton, Tooltip } from "components";

export interface InputImageCardProps extends Omit<InputNumberProps, "label"> {
  image: {
    imageSrc: string;
    imageAlt?: string;
    imageSize?: number;
  };
  title: string;
  loading?: boolean;
  disabled?: boolean;
  onChange: (value: number | null) => void;
}

export const InputImageCard: React.FC<InputImageCardProps> = ({
  image,
  suffix,
  precision,
  initialValue,
  title,
  loading,
  disabled,
  value,
  onChange,
  tooltip,
  ...rest
}) => {
  const { imageSrc, imageAlt, imageSize = 48 } = image;
  const isActive = value !== null && value !== 0;
  const displayValue = value === 0 ? null : value;

  if (loading) {
    return (
      <Card className="padding-125 width-100 margin-top-100">
        <Flex gap="28px" align="center">
          <div className="skeleton-containers icon">
            <Skeleton type="block" height="48px" width="48px" className="skeleton-rectangular" />
          </div>

          <Flex className="width-100" vertical>
            <div className="skeleton-containers form-title margin-bottom-25">
              <Skeleton type="title" width="180px" className="skeleton-rectangular" />
            </div>
          </Flex>

          <div className="skeleton-containers edit">
            <Skeleton type="block" width="58px" height="36px" className="skeleton-rectangular" />
          </div>
        </Flex>
      </Card>
    );
  }

  return (
    <Card
      className={`padding-top-75 padding-bottom-75 padding-right-100 padding-left-100 width-100 margin-top-100 input-image-card no-cursor ${
        disabled ? "disabled" : ""
      }${isActive ? " active" : ""}`}
    >
      <Flex align="center" justify="space-between" gap="12px">
        {/* Image */}
        <Tooltip title={tooltip}>
          <Flex align="center" justify="center" className="image-container" gap={12}>
            <Image
              src={imageSrc || "https://klimpublic.s3.eu-central-1.amazonaws.com/footprintingImagePlaceholder.png"}
              alt={imageAlt}
              width={imageSize}
              height={imageSize}
              className="selected-image-card-image"
              key=""
              preview={false}
              images={[]}
            />

            {/* Title Column */}
            <p className="paragraph-m">{title}</p>
          </Flex>
        </Tooltip>

        {/* Input Number */}
        <div className="center">
          <InputNumber
            label=""
            suffix={suffix}
            initialValue={initialValue}
            precision={precision}
            className="input-number-container no-label"
            disabled={disabled}
            value={displayValue}
            onChange={onChange}
            rules={rest.rules}
            {...rest}
            placeholder="0"
          />
        </div>
      </Flex>
    </Card>
  );
};

export default InputImageCard;
